import { Step } from 'react-joyride'

export const tourGuideSteps = (isSmall: boolean): Step[] => {
  const desktopSteps: Step[] = [
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Home',
      content: (
        <span>
          This is the home page. From here, you can view our products and keep up to date on the
          latest news.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-end',
      target: '#tour-anchor',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      spotlightPadding: 4,
      title: 'Products',
      placement: 'bottom-end',
      content: (
        <span>
          You can access Phuture&apos;s world-class index products easily from the home page.
          Let&apos;s select PDI to find out more.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
        },
      },
      target: '#product-PDI',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Product page',
      content:
        'This is the product page. Here, you are able to learn more about the benefits of each product.',
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-end',
      target: '#tour-anchor',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Investment widget',
      content: (
        <span>
          The widget makes it easy to invest in each product. We&apos;ll come back to this later.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'left',
      target: '#tour-demo-chart',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Information tabs',
      content: (
        <span>Specific information about each product can be accessed through the page tabs.</span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-start',
      target: '#tour-performance',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Product performance',
      content: (
        <span>
          The performance section provides an insight into the product&apos;s performance.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      spotlightPadding: 30,
      placement: 'bottom',
      target: '#tour-chart',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Returns',
      content: (
        <span>
          The returns section allows you to see how the product has performed compared to other
          major assets.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'top',
      target: '#tour-returns',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Making an investment',
      content: (
        <span>
          Now that we&apos;ve seen what the product has to offer, let&apos;s simulate an investment.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'left',
      target: '#tour-demo-chart',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      spotlightPadding: 0,
      title: 'Making an investment',
      content: (
        <span>
          First, let&apos;s make sure we&apos;re in the right mode. Currently, the widget is in sell
          mode. Let&apos;s change that by selecting &apos;buy&apos;.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: isSmall ? 'top' : 'left',
      target: '#tour-buy-tab',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      title: 'Making an investment',
      content: (
        <span>
          Next, we&apos;ll need to enter an amount to invest. For this demonstration, we&apos;ll use
          1 ETH. Enter &apos;1&apos; to continue.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: isSmall ? 'top' : 'left',
      target: '#tour-input-box',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      title: 'Making an transaction',
      content: (
        <span>
          The &apos;Tokens received&apos; section shows what you&apos;ll receive in the transaction.
          In this case, you&apos;ll receive 15 PDI.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: isSmall ? 'top' : 'left',
      target: '#tour-received-box',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      title: 'Transaction Widget',
      content: (
        <span>
          Now you&apos;re all set! Select &apos;confirm transaction&apos; to simulate this process
          and purchase some PDI.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'left',
      target: '#tour-confirm-transaction',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      title: 'Investment success!',
      content: (
        <span>
          Congratulations, you&apos;ve purchased your first Phuture index product. Lets take a look
          at your portfolio by selecting &apos;View portfolio&apos;.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-start',
      target: '#view-portfolio',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Portfolio page',
      content: (
        <span>
          The portfolio page is where you can access information about your investments. The
          &apos;All portfolio&apos; section shows your overall portfolio statistics.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-end',
      target: '#tour-anchor',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Portfolio chart',
      content: <span>The chart shows you the value of your portfolio over time.</span>,
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-end',
      target: '#tour-chart',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Portfolio composition',
      content: (
        <span>
          Here you can see what percentage of your portfolio is allocated to each investment.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'right',
      target: '#tour-composition',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      spotlightClicks: true,
      spotlightPadding: 25,
      title: 'Individual investments',
      content: (
        <span>
          On the left is a dropdown containing all of your individual investments. Select{' '}
          <b>Phuture DeFi Index</b> and have a look at how it&apos;s doing.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'right',
      target: '#tour-portfolio-select-box',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'Individual investments',
      content: (
        <span>
          Here you will find the key details of your investment including your total return and
          average purchase price.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom',
      target: '#tour-investment-metrics',
    },
    {
      disableBeacon: true,
      disableOverlayClose: true,
      title: 'End of tour',
      content: (
        <span>
          That&apos;s all you need to know to get started with the Phuture platform! Select
          &apos;end&apos; to complete the tour.
        </span>
      ),
      floaterProps: {
        hideArrow: true,
        styles: {
          floater: {
            filter: 'none',
          },
          arrow: {
            border: '1px solid black;',
          },
        },
      },
      placement: 'bottom-end',
      target: '#tour-anchor',
    },
  ]

  return desktopSteps
}
